import { useLocation, Link } from 'react-router-dom';
import { Breadcrumb } from 'antd';

type Props = {
  homepath: string;
  title: string;
};

// Custom breadcrumb mappings for pages that need parent links
const customBreadcrumbMappings: { [key: string]: { parent: string; parentLink: string } } = {
  '/app/bulkUpload': { parent: 'Supplier', parentLink: '/app/supply' },
  '/app/bulkUploadSupplyIngredients': { parent: 'Supplier', parentLink: '/app/supply' },
  '/app/supply/wizard': { parent: 'Supplier', parentLink: '/app/supply' },
};

const BreadCrumb = (props: Props) => {
  const location = useLocation();
  const breadCrumbView = () => {
    const { pathname } = location;
    const pathnames = pathname.split('/').filter((item) => item);
    
    // Check if this page has custom breadcrumb mapping
    const customMapping = customBreadcrumbMappings[pathname];

    return (
      <Breadcrumb>
        {pathnames.length > 0 ? (
          <Breadcrumb.Item className="b1 breadcrumb-link">
            <Link to="/app/dashboard">{props.homepath}</Link>
          </Breadcrumb.Item>
        ) : (
          <Breadcrumb.Item className="b1 breadcrumb-link">
            {props.homepath}
          </Breadcrumb.Item>
        )}
        {customMapping ? (
          // Use custom parent breadcrumb
          <>
            <Breadcrumb.Item className="b1 breadcrumb-link">
              <Link to={customMapping.parentLink}>{customMapping.parent}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item className="b2">
              {props.title}
            </Breadcrumb.Item>
          </>
        ) : (
          // Default behavior - use URL path
          pathnames.slice(1).map((name, index) => {
            const routeTo = `/app/${pathnames[1]}/`;
            const isLast = index === pathnames.slice(1).length - 1;
            return isLast ? (
              <Breadcrumb.Item key={index} className="b2">
                {props.title}
              </Breadcrumb.Item>
            ) : (
              <Breadcrumb.Item key={index} className="b1 breadcrumb-link">
                <Link to={`${routeTo}`}>{name}</Link>
              </Breadcrumb.Item>
            );
          })
        )}
      </Breadcrumb>
    );
  };

  return <>{breadCrumbView()}</>;
};

export default BreadCrumb;
